import {
  ECommonDialogType,
  openDialog,
} from "components/molecules/CommonDialog";
import { I18nTranslator, translations } from "utils/i18n";
import configureStore from "redux/configurations/configureStore";
import { Typography } from "@mui/material";
import { Fragment } from "react";
import { isEmpty } from "lodash";
import { StringHelper } from "helpers";
import { Box } from "@mui/system";
import { AppConfigActions } from "redux/actions";

export const open = (props: {
  title: string;
  message: string;
  onConfirm?: () => void;
  type?: ECommonDialogType;
  isCancel?: boolean;
  onCancel?: () => void;
}) => {
  const buttons = props.isCancel
    ? [
        {
          isCancel: true,
          title: I18nTranslator(translations.button.cancel),
          onClick: props.onCancel
        },
        {
          title: I18nTranslator(translations.button.confirm),
          onClick: props.onConfirm,
        },
      ]
    : [
        {
          title: I18nTranslator(translations.button.confirm),
          onClick: props.onConfirm,
        },
      ];
  openDialog({
    title: props.title,
    type: props.type || ECommonDialogType.NORMAL,
    message: props.message,
    buttons: buttons,
  });
};

export const openConfirmImportDialog = (props: {
  title: string;
  fileName: string;
  onConfirm: () => void;
}) => {
  openDialog({
    title: props.title,
    type: ECommonDialogType.NORMAL,
    component: (
      <Typography>
        Bạn có muốn nhập phiếu <strong>{props.fileName}</strong>
      </Typography>
    ),
    buttons: [
      {
        title: I18nTranslator(translations.button.cancel),
        isCancel: true,
      },
      {
        title: I18nTranslator(translations.button.confirm),
        onClick: props.onConfirm,
      },
    ],
  });
};

export const openConfirmDeleteDialog = (props: {
  itemName?: string;
  onDelete: () => void;
}) => {
  openDialog({
    title: I18nTranslator(translations.dialog.warning),
    type: ECommonDialogType.ERROR,
    message: props.itemName || "",
    buttons: [
      {
        title: I18nTranslator(translations.button.cancel),
        isCancel: true,
      },
      {
        title: I18nTranslator(translations.button.delete),
        onClick: props.onDelete,
      },
    ],
  });
};

export const showImportErrorDialog = () => {
  const store = configureStore().store.getState();
  const errors = store.ErrorReducer.errors as any;

  openDialog({
    title: I18nTranslator(translations.dialog.warning),
    type: ECommonDialogType.ERROR,
    component: (
      <Fragment>
        {StringHelper.isStringArray(errors.errors) ? (
          errors.errors &&
          errors.errors.map((error: string) => <Typography>{error}</Typography>)
        ) : (
          <Typography>
            {!isEmpty(errors.message)
              ? errors.message[0].Text
              : !isEmpty(errors.errors)
              ? errors.errors
              : "Không thế nhập phiếu, vui lòng kiểm trả lại định dạng phiếu và thử lại"}
          </Typography>
        )}
      </Fragment>
    ),
    buttons: [
      {
        title: "Try again",
        buttonProps: {
          color: "primary",
          variant: "contained",
        },
        onClick: () =>
          configureStore().store.dispatch(
            AppConfigActions.clearAction.request()
          ),
      },
    ],
  });
};
